import {
  ACCOUNT_PATH,
  USER_MANAGEMENT_PATH,
  TENANT_PATH,
  DEVICE_CONFIG_PATH,
  RULES_CONFIG_PATH,
  REPORTS_LIST_PATH,
  ASSET_DATA_IMPORT_PATH,
  // MANAGE_GROUP_TYPE_PATH,
  DATA_MODEL_TYPE_PATH,
} from '../../routing/paths.constants';
import { ReactComponent as userSVG } from '../../../assets/icons/user.svg';
import { ReactComponent as usersSVG } from '../../../assets/icons/team.svg';
import { ReactComponent as tenantsSVG } from '../../../assets/icons/hierarchy.svg';
import { ReactComponent as devicesSVG } from '../../../assets/icons/devices.svg';
import { ReactComponent as rulesSVG } from '../../../assets/icons/rules.svg';
import { ReactComponent as reportsSVG } from '../../../assets/icons/reports.svg';
import { ReactComponent as assetsSVG } from '../../../assets/icons/assets.svg';
import { ReactComponent as groupTypesSVG } from '../../../assets/icons/groupTypes.svg';

const SidebarItems = [
  {
    key: '0',
    title: 'Reports',
    pathname: REPORTS_LIST_PATH,
    icon: reportsSVG,
    permissionId: 'reports',
  },
  {
    key: '1',
    title: 'Rules',
    pathname: RULES_CONFIG_PATH,
    icon: rulesSVG,
    permissionId: 'rulesold,rules',
  },
  {
    key: '2',
    title: 'Asset Types',
    pathname: ASSET_DATA_IMPORT_PATH,
    icon: assetsSVG,
    permissionId: 'assetTypes',
  },
  {
    key: '3',
    title: 'Users',
    pathname: USER_MANAGEMENT_PATH,
    icon: usersSVG,
    permissionId: 'users',
  },
  {
    key: '4',
    title: 'Devices',
    pathname: DEVICE_CONFIG_PATH,
    icon: devicesSVG,
    permissionId: 'devices',
  },

  {
    key: '5',
    title: 'Facilities',
    pathname: TENANT_PATH,
    icon: tenantsSVG,
    permissionId: 'facilities',
  },
  // {
  //   key: '6',
  //   title: 'Organization',
  //   pathname: MANAGE_GROUP_TYPE_PATH,
  //   icon: groupTypesSVG,
  //   permissionId: 'organization',
  // },
  {
    key: '7',
    title: 'Data Model',
    pathname: DATA_MODEL_TYPE_PATH,
    icon: groupTypesSVG,
    permissionId: 'datamodel',
  },
  {
    key: '8',
    title: 'Account',
    pathname: ACCOUNT_PATH,
    icon: userSVG,
    permissionId: 'account',
  },
];

export default SidebarItems;
